import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { TableDataCell } from "@digital-services/ui";
import { CopyToClipboard, TableDataCellTruncated } from "@ds-cps/ui";

import { Organization } from "@organization/models/Organization";

import { formatterShort } from "@utils/time-utils";

import { OrganizationStatusIcon } from "../status/OrganizationStatusIcon";

interface Props {
  organization: Organization;
}

export const OrganizationDataRow: FC<Props> = (props: Props) => {
  const { organization } = props;

  const { t: tCommon } = useTranslation(undefined, {
    keyPrefix: "common"
  });

  return (
    <tr
      key={`table-row-${organization.id}`}
      data-testid={`table-row-${organization.id}`}
    >
      <TableDataCellTruncated>
        <Link
          to={`/organizations/${organization.id}`}
          data-testid={`link-${organization.id}`}
          className="hover:underline hover:underline-offset-2"
          title={organization.name.length > 50 ? organization.name : undefined}
        >
          {organization.name}
        </Link>
      </TableDataCellTruncated>

      <TableDataCell className="group">
        {organization.externalId || ""}

        {organization.externalId ? (
          <span className="invisible ml-1 group-hover:visible">
            <CopyToClipboard
              value={organization.externalId}
              message={tCommon("copied-to-clipboard", {
                entityName: "External ID"
              })}
            />
          </span>
        ) : null}
      </TableDataCell>
      <TableDataCell>{organization.countryName}</TableDataCell>
      <TableDataCell>{organization.type}</TableDataCell>
      <TableDataCell>
        <OrganizationStatusIcon status={organization.status} />
      </TableDataCell>
      <TableDataCell>{formatterShort(organization.createdOn)}</TableDataCell>
    </tr>
  );
};
